/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AudioPlayer from "../Services/AudioPlayer";
import AboutService from "../Services/About"
import { _get_i18Lang } from "../i18n";

export interface IAudioItem {
  ctime: number;
  id: string;
  slug?: string;
  name: string;
  author: string;
  playing: boolean;
  audioPath: string;
  audioUrl: string;
  pravachanPath: string;
  pravachanUrl: string;
  lyricsPath: string;
  lyricsHash: string;
  index: number
}
interface IAudiosContextProps {
  isMinimise: boolean;
  setIsMinismise: React.Dispatch<React.SetStateAction<boolean>>;
  audiosList: IAudioItem[];
  currentAudio: IAudioItem | null;
  audioInfoDialog: boolean;
  setAudioInfoDialog: () => void;
  setAudiosList: React.Dispatch<React.SetStateAction<IAudioItem[]>>;
  playAudio: (id: string, index: number, audio?: IAudioItem | null) => void;
  close: () => void;
  next: () => void;
  prev: () => void;
  lyrt: () => string;
  repeat: () => void;
  playbackspeed: (e: any) => void;
  showList: boolean;
  setShowList: React.Dispatch<React.SetStateAction<boolean>>

}

const AudioContext = React.createContext<IAudiosContextProps>({} as any);
export function AudioProvider(props: { children: any }) {
  const [currentAudio, setCurrentAudio] = useState<IAudioItem | null>(null);
  const [audiosList, setAudiosList] = useState<IAudioItem[]>([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [audioIndex, setAudioIndex] = useState(0);
  const [audioinfoDialog, setAudioinfoDialog] = useState(false);
  const [lyrtxt, setlyrtxt] = useState("");
  const [audioId, setaudioId] = useState("");
  const [Type, setType] = useState<any | undefined>(undefined);
  const [suff, setSuff] = useState<boolean>(false)
  const [isMinimise, setIsMinismise] = useState<boolean>(false)
  const [showList, setShowList] = useState<boolean>(true);

  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();

  // const getRouteType = () => {
  //   const storedType = localStorage.getItem("type");
  //   return storedType === "pravachans" ? "pravachans" : "audios";
  // };
  const getRouteType = () => {
    if (typeof window === "undefined") {
      return "audios";
    }

    const pathname = window.location.pathname;

    if (pathname.startsWith("/pravachans/")) {
      return "pravachans";
    }

    return "audios";
  };
  const getCurrentSlug = () => {
    if (typeof window === "undefined") return "";
    const pathname = window.location.pathname;
    const clean = pathname.replace(/^\/+|\/+$/g, "");
    const segments = clean.split("/");
    const last = segments[segments.length - 1];
    return last && !["audios", "pravachans"].includes(last) ? last : "";
  };

  const playAudio = (id: string, index: number, audio?: IAudioItem | null) => {
    if (!id) return;

    const currentTime = new Date().toISOString();
    const item =
      audio ??
      audiosList.find((audio) => audio.id === id || audio.slug === id) ??
      currentAudio;
    // const routeType = getRouteType();
    // const currentSlug = getCurrentSlug();
    // const targetSegment = currentSlug || item?.slug || id;
    // const targetPath = `/${routeType}/${targetSegment}`;
    const routeType = getRouteType();

const targetSegment =
  item?.slug ||
  getCurrentSlug() ||
  id;

const targetPath = `/${routeType}/${targetSegment}`;

    setAudioIndex(index);
    setaudioId(id);

    if (item) {
      setCurrentAudio({ ...item, playing: true, index });
    }

    localStorage.setItem("type", routeType);
    localStorage.setItem("lan", _get_i18Lang());

    if (
      typeof window !== "undefined" &&
      window.location.pathname !== targetPath &&
      window.location.pathname !== `${targetPath}/`
    ) {
      navigate(targetPath, { replace: true });
    }

    let url: any = routeType;
    AboutService.updateUserActivity(url, id, currentTime).then((res: any) => {
      console.log("res", res);
    });
  };
  const close = () => {
    setAudiosList([]);
    setaudioId("");
    setCurrentAudio(null);
    navigate(`/${getRouteType()}`);
  };
  const next = () => {
    setAudioIndex(audioIndex < audiosList?.length - 1 ? (audioIndex + 1) : (audiosList?.length - 1 === audioIndex ? 0 : audiosList?.length));
    setCurrentAudio({ ...audiosList[audiosList?.length - 1 === audioIndex ? 0 : audioIndex + 1] });
    let ind = audiosList?.length - 1 === audioIndex ? 0 : audioIndex + 1
    let dt = audiosList[ind]
    playAudio(dt?.id, ind, dt)
  };

  const prev = () => {
    setAudioIndex(audioIndex === 0 ? audiosList?.length - 1 : audioIndex < audiosList?.length + 1 ? (audioIndex - 1) : 0);

    setCurrentAudio({ ...audiosList[audioIndex === 0 ? audiosList?.length - 1 : audioIndex < audiosList?.length + 1 ? (audioIndex - 1) : 0] });
    let ind = audioIndex === 0 ? audiosList?.length - 1 : audioIndex < audiosList?.length + 1 ? (audioIndex - 1) : 0
    let dt = audiosList[ind]
    playAudio(dt?.id, ind, dt)
    // setAudioIndex( audioIndex === 0 ? audiosList.length -1  :audioIndex < audiosList.length + 1 ? (audioIndex - 1): 0);
    // setCurrentAudio({ ...audiosList[audioIndex === 0 ? audiosList.length -1  :audioIndex < audiosList.length + 1 ? (audioIndex - 1): 0], playing: true});
  };

  const repeat = () => {
    setSuff((x: boolean) => !x)
  }

  const lyrt = () => {
    return lyrtxt;
  };

  const playbackspeed = () => {
    var audio = new Audio();
    audio.play();
    var speedlist = document.getElementById("speedlist");
    speedlist?.addEventListener("change", changeSpeed);
    function changeSpeed(e: any) {
      audio.playbackRate = e.target.value;
    }
    window.addEventListener("load", playbackspeed);
  }


  // for ProgressBar

  // const onProgress = () => {
  //   if (!element.buffered || !bufferRef.current) return;
  //   if (!element.buffered.length) return;
  //   const bufferedEnd = element.buffered.end(element.buffered.length - 1);
  //   const duration = element.duration;
  //   if (bufferRef && duration > 0) {
  //     bufferRef.current.style.width = (bufferedEnd / duration) * 100 + "%";
  //   }
  // };

  const LoadLyrics = (id: string) => {
    // Ensure rabbit-lyrics script is available. Fetch it first and only
    // execute if it looks like JS — prevents executing HTML (index.html)
    // when the asset path is missing on the server.
    const tryLoadRabbit = async () => {
      try {
        if ((window as any).RabbitLyrics || document.getElementById("rabbitlyrics")) return;
        const url = (process.env.PUBLIC_URL || "") + "/assets/rabbitLyrics/rabbit-lyrics.js";
        const resp = await fetch(url, { cache: "no-store" });
        if (!resp.ok) return;
        const contentType = resp.headers.get("content-type") || "";
        const text = await resp.text();
        if (contentType.includes("javascript") || !text.trim().startsWith("<")) {
          const blob = new Blob([text], { type: "text/javascript" });
          const blobUrl = URL.createObjectURL(blob);
          const script = document.createElement("script");
          script.id = "rabbitlyrics";
          script.src = blobUrl;
          document.body.appendChild(script);
          script.onload = () => {
            URL.revokeObjectURL(blobUrl);
          };
        } else {
          console.error("rabbit-lyrics fetch returned HTML — skipping execution", url);
        }
      } catch (e) {
        console.error("Failed to fetch rabbit-lyrics script:", e);
      }
    };
    // Fire-and-forget; lyrics library is only needed for enhanced UI.
    void tryLoadRabbit();

    var todayDate = new Date();
    var signKey = localStorage.getItem("SignKey");
    //= "b1a176ce-f1bf-4f3e-a660-b2e911be7361";

    //var token = localStorage.getItem("Token");
    var token = localStorage.getItem("Token");

    let securekey = window.btoa(
      signKey + "|" + id + "|2|" + todayDate.toISOString().substr(0, 10)
    );
    var rawFile = new XMLHttpRequest();
    var proc = //`${process.env.REACT_APP_API_URL}/api/Pravachans/`;
      getRouteType() === "pravachans"
        ? `${process.env.REACT_APP_API_URL}/api/Pravachans/`
        : `${process.env.REACT_APP_API_URL}/api/Audios/`;
    rawFile.open(

      "GET",
      // currentAudio?.lyricsPath == "" ? currentAudio.lyricsPath : "",
      proc + id + `/lyrics`,
      false
    );
    rawFile.setRequestHeader("Authorization", "Bearer " + token);
    rawFile.setRequestHeader("X-Signature", securekey);
    rawFile.setRequestHeader("X-Plateform", "2");
    rawFile.onreadystatechange = function () {
      if (rawFile.readyState === 4) {
        if (rawFile.status === 200 || rawFile.status === 0) {
          var allText = "";
          allText = rawFile.responseText;
          //localStorage.setItem("lyricsText", allText);
          setlyrtxt(allText);
        } else if (rawFile.status === 404) {
          //localStorage.setItem("lyricsText", "");
          setlyrtxt("");
          allText = "";
        }
      }
    };
    rawFile?.send();
  };

  const setAudioInfoDialog = () => {
    if (audioinfoDialog) {
      setAudioinfoDialog(false);
    } else {
      setAudioinfoDialog(true);
    }
  };

  useEffect(() => {
    setIsLoaded(true);
  }, [currentAudio]);

  // useEffect(() => {
  //   setType(localStorage.getItem("type"));
  //   if (audioId) {
  //     setLoading(true);
  //     AudioPlayer.getAudiosById(audioId, Type).then((res) => {
  //       if (res?.status) {
  //         setCurrentAudio(null);
  //         setCurrentAudio({ ...res.result, playing: true });
  //         setLoading(false);
  //       }
  //     });
  //     if (currentAudio?.lyricsPath !== "") LoadLyrics(audioId);
  //   }
  // }, [audioId, Type, suff]);
  useEffect(() => {
  const routeType = getRouteType();

  setType(routeType);

  if (audioId) {
    setLoading(true);

    AudioPlayer.getAudiosById(audioId, routeType)
      .then((res) => {
            console.log("routeType =", routeType);
    console.log("getAudiosById response =", res);
        const audio =
          Array.isArray(res?.result?.items)
            ? res.result.items[0]
            : res?.result;
    console.log("currentAudio =", audio);
        if (res?.status && audio?.id) {
          setCurrentAudio({
            ...audio,
            playing: true
          });
        }

        
      })


      .catch((error) => {
        console.error("Audio load error:", error);
      })
      .finally(() => {
        setLoading(false);
      });

    LoadLyrics(audioId);
  }
}, [audioId, suff]);

  if (!isLoaded) return null;

  return (
    <AudioContext.Provider
      value={{
        isMinimise,
        setIsMinismise,
        currentAudio,
        playAudio,
        audiosList,
        audioInfoDialog: audioinfoDialog,
        setAudioInfoDialog,
        setAudiosList,
        close,
        next,
        prev,
        lyrt,
        repeat,
        playbackspeed,
        showList,
        setShowList
      }}
      {...props}
    />
  );
}
export function useAudio() {
  const context = React.useContext(AudioContext);
  if (context === undefined) {
    throw new Error(`useAudio must be used within a AudioProvider`);
  }
  return context;
}
function useRouteMatch(arg0: {
  path: string;
  strict: boolean;
  sensitive: boolean;
}) {
  throw new Error("Function not implemented.");
}
